<template>
	<vs-popup
		:title="$t('indicateFailureReason')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<ul class="leftx set-ticket-failed__list">
			<li
				v-for="(item, index) in failReasons"
				:key="index"
			>
				<vs-radio
					v-model="reason"
					:vs-value="item.id"
					class="set-ticket-failed__item"
				>{{ item.name }}</vs-radio>
			</li>
		</ul>
		<div class="set-ticket-failed__controls">
			<vs-button
				color="primary"
				@click="confirm"
			>{{ $t('save') }}</vs-button>

			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('cancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "SetStageFailedPopup",
	mixins: [databaseManager],
	props: {
		active: 		{ default: false, type: Boolean },
	},
	data() {
		return {
			reason: null,
			failReasons: []
		}
	},
	watch: {
		activeProp(newValue) {
			if(newValue === false) {
				this.reason = null;
			}
		}
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			if(this.reason === null) return;

			this.$emit("confirm", this.reason);
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	},
	async mounted() {
		this.failReasons = await this.dbGetFailReasons();
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
}
</style>
